import React from "react";
import ConfirmationModal from "../ConfirmationModal.jsx";
import { buildLoadingConstraintRecoveryDialog } from "../../utils/loadingConstraintSourceChanges.js";

export default function LoadingConstraintRecoveryConfirmation({ recovery, truckLabel, isBusy, onCancel, onConfirm, errorMessage }) {
  if (!recovery) return null;
  return (
    <ConfirmationModal
      {...buildLoadingConstraintRecoveryDialog(recovery, truckLabel)}
      contentDensity="compact"
      panelSize="narrow"
      eyebrow="Horaires de meunerie"
      tone="accent"
      confirmLabel={isBusy ? "Déplacement en cours…" : "Déplacer vers Suspendues"}
      isBusy={isBusy}
      onCancel={onCancel}
      onClose={onCancel}
      onConfirm={onConfirm}
      errorMessage={errorMessage}
    />
  );
}
